<template>
  <div>
    <p v-if="title" class="font-weight-bold text-skribbleu my-4">
      {{ title }}
    </p>
    <v-text-field
      v-model="vatNumber"
      variant="filled"
      hide-details
      :label="$t('global.vat_number.label')"
      :disabled="isInputDisabled"
    />
    <skr-checkbox v-model="isNoReverseChargeRequested" class="mt-2" :label="$t('input.vat.no_reverse_charge')" />
  </div>
</template>

<script lang="ts">
import SkrCheckbox from '@/components/SkrCheckbox.vue'

export default defineComponent({
  components: {
    SkrCheckbox,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue', 'disable'],
  data() {
    return {
      isNoReverseChargeRequested: false,
    }
  },
  computed: {
    isInputDisabled(): boolean {
      return this.isNoReverseChargeRequested
    },
    vatNumber: {
      get(): string {
        return this.modelValue
      },
      set(newValue: string) {
        this.$emit('update:modelValue', newValue)
      },
    },
  },
  watch: {
    isInputDisabled: {
      handler(isDisabled: boolean) {
        this.$emit('disable', isDisabled)
        if (isDisabled) {
          this.$emit('update:modelValue', '')
        }
      },
      immediate: true,
    },
  },
})
</script>

<style lang="sass" scoped>
.country-info
  display: flex
  align-items: center
  font-size: 0.75em
  * + *
    margin-left: 0.5rem
</style>
